import { loadingStore } from '@/lib/api/client';
import { useStore } from '@/lib/store';

/**
 * The bar across the top while requests are in flight.
 *
 * Driven by the client's ref-counted store rather than by any one query, so it
 * reflects "the portal is busy" rather than "this component is busy" — which is what
 * the user is actually asking when they look at it.
 */
export function TopProgress() {
  const loading = useStore(loadingStore);

  return (
    <div
      aria-hidden={!loading}
      className={`pointer-events-none fixed inset-x-0 top-0 z-50 h-0.5 transition-opacity duration-200 ${
        loading ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="h-full w-full origin-left animate-[progress_1.4s_ease-in-out_infinite] bg-accent" />
      <style>{`
        @keyframes progress {
          0%   { transform: scaleX(0);   opacity: 1; }
          50%  { transform: scaleX(0.7); opacity: 1; }
          100% { transform: scaleX(1);   opacity: 0; }
        }
      `}</style>
    </div>
  );
}
